module.exports = __webpack_public_path__ + "static/media/donors-logo.b58df52e.svg";